import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { LanguageRouterLinkDirective } from "src/app/shared/directives/language-router-link.directive";

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  standalone: true,
  imports: [CommonModule,LanguageRouterLinkDirective]
})
export class NavigationComponent {
  @Input() hasSkip: boolean = false;
  @Input() hasPrevious: boolean = false;
  @Input() isLastStep: boolean = false;
  @Input() redirectLink: string = '';
  @Output() goToPrevious = new EventEmitter();
  @Output() goToNext = new EventEmitter();
  @Output() skipTo = new EventEmitter();


  constructor() {
  }

  goBack(): void {
    this.goToPrevious.emit();
  }

  goNext(): void {
    this.goToNext.emit();
  }

  skipStep(): void {
    this.skipTo.emit();
  }
}
